import React, {useContext, useEffect, useRef, useState} from "react";
import {
  Box,
  Button,
  Checkbox, Divider,
  Fade,
  FormControlLabel,
  Grid,
  Stack,
  TextField, Toolbar, Tooltip,
  Typography
} from "@mui/material";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {grey} from "@mui/material/colors";
import {ArrowForwardIos} from "@mui/icons-material";
import {toast} from "react-toastify";
import {SignInContext} from "../../../context/SignInContext";
import {IconBrandGoogle} from "@tabler/icons-react";
import {validatePasswordStrength} from "../../../utils/functions";

export const ChangePasswordPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const {onChangePassword} = useContext(SignInContext);
  const navigate = useNavigate();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');

  const loginHandle = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword || password !== confirmPassword) {
      toast.error("Please enter password and both passwords must match");
      return;
    }
    const checkPassword = validatePasswordStrength(password || "");
    if (checkPassword.length) {
      toast.error(<>{checkPassword?.map(i => <Typography fontSize={14} fontWeight={500}>* {i}</Typography>)}</>)
      return;
    }
    const toastId = toast.loading("Sending request to change password")
    try {
      await onChangePassword({password, token});
      toast.update(toastId, {
        type: "success",
        render: `Password changed successfully, please check your email address for confirmation`,
        isLoading: false,
        autoClose: 2000
      });
      setPassword("");
      setConfirmPassword("");
      navigate("/login")
    } catch (err) {
      toast.update(toastId, {
        type: "error", render: err?.message || `Please try again later.`, isLoading: false, autoClose: 2000
      });
    }
  }

  return (
    <Grid container sx={{width: "100%", height: "100%", bgcolor: "rgb(255,255,255)"}}>
      <Grid item gap={2} xs={12} justifyContent={"space-between"} className={"bg-primary-gradient"} sx={{display: "flex", flexDirection: "column", height: "100%"}}>
        <Toolbar>
          <img src={"/logo.svg"} alt={"logo"} width={30}/>
        </Toolbar>
        <Stack
          maxWidth={"sm"} direction={"column"} gap={3}
          sx={{maxWidth: "400px", width: "100%", px: 3, py: 5, borderRadius: 4, bgcolor: "#fefefe", mx: "auto"}}
          justifyContent={'center'} alignItems={"center"}
        >
          {/*HEADER*/}
          <Stack direction={"column"} gap={2} sx={{width: '100%'}}>
            {/*TITLE*/}
            <Typography color={"dark.main"} fontSize={40} variant={'h3'} textAlign={"center"}
                        fontWeight={"bold"}>Change Password</Typography>
            {/*SIGN UP*/}

            <Box sx={{textAlign: "center"}}>
              <Typography sx={{color: grey[700]}} component={"span"}>Already have an account?</Typography>
              <Link to={"/login"} style={{
                paddingLeft: 5,
                color: "#252525",
                fontWeight: 'bold',
                textDecoration: "none",
                cursor: "pointer"
              }}>
                Sign in
              </Link>
            </Box>
          </Stack>
          {/*LOGIN WITH MAIL*/}
          <Stack component={"form"} onSubmit={loginHandle} direction={"column"} gap={2} sx={{width: '100%'}}>
            <Box>
              <Typography fontWeight={600} gutterBottom>Password</Typography>
              <Tooltip title={<>
                <Typography fontSize={12}>
                  Your password must be 10-127 characters long<br/>
                  include at least one number,<br/>
                  both uppercase and lowercase letters,<br/>
                  and one special character (!#@$%^&*)(+=._-).
                </Typography>
              </>}>
                <TextField
                  variant={"outlined"}
                  required
                  fullWidth
                  disabled={!token}
                  value={password}
                  type={"password"}
                  onChange={e => setPassword(e.target.value)}
                  placeholder={"**********"}
                />
              </Tooltip>
            </Box>
            <Box>
              <Typography fontWeight={600} gutterBottom>Confirm Password</Typography>
              <Tooltip title={<>
                <Typography fontSize={12}>
                  Your password must be 10-127 characters long<br/>
                  include at least one number,<br/>
                  both uppercase and lowercase letters,<br/>
                  and one special character (!#@$%^&*)(+=._-).
                </Typography>
              </>}>
                <TextField
                  variant={"outlined"}
                  required
                  fullWidth
                  disabled={!token}
                  value={confirmPassword}
                  type={"password"}
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder={"**********"}
                />
              </Tooltip>
            </Box>
            <Button
              fullWidth
              type={"submit"}
              variant={"modal"}
              disabled={!token || !password || !confirmPassword || password !== confirmPassword}
              sx={{
                textTransform: "capitalize",
                fontWeight: "bold",
                borderRadius: "8px !important"
              }}
              endIcon={<ArrowForwardIos style={{fontSize: 13}}/>}
            >
              Continue
            </Button>

          </Stack>
        </Stack>
        <Toolbar sx={{justifyContent: "space-between"}}>
          <img src={"/logo-black.svg"} alt={"logo"} width={60}/>
          <a href={"https://openbrain.io"} target={"_self"}
             style={{fontSize: 12, textDecoration: "none", color: "#252525"}}>openbrain.io</a>
        </Toolbar>
      </Grid>
    </Grid>
  )
}